import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@/features/auth/LoginPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { MapPage } from '@/features/map/MapPage';
import { DevicesPage } from '@/features/devices/DevicesPage';
import { DeviceDetailPage } from '@/features/devices/DeviceDetailPage';
import { HealthPage } from '@/features/devices/HealthPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { EventsReportPage } from '@/features/reports/EventsReportPage';
import { SummaryReportPage } from '@/features/reports/SummaryReportPage';
import { TripsReportPage } from '@/features/reports/TripsReportPage';
import { StopsReportPage } from '@/features/reports/StopsReportPage';
import { RouteReportPage } from '@/features/reports/RouteReportPage';
import { SpeedReportPage } from '@/features/reports/SpeedReportPage';
import { InsuranceReportPage } from '@/features/reports/InsuranceReportPage';
import { UsageReportPage } from '@/features/reports/UsageReportPage';
import { GeofenceEventsReportPage } from '@/features/reports/GeofenceEventsReportPage';
import { HoursReportPage } from '@/features/reports/HoursReportPage';
import { GeofencesPage } from '@/features/geofences/GeofencesPage';
import { ConditionsPage } from '@/features/conditions/ConditionsPage';
import { ChecklistPage } from '@/features/checklist/ChecklistPage';
import { RentalPage } from '@/features/rental/RentalPage';
import { CentralPage } from '@/features/central/CentralPage';
import { PointsPage } from '@/features/points/PointsPage';
import { PointDetailPage } from '@/features/points/PointDetailPage';
import { NavigatorPage } from '@/features/navigator/NavigatorPage';
import { RoutesPage } from '@/features/navigator/RoutesPage';
import { MaintenancePage } from '@/features/maintenance/MaintenancePage';
import { NotificationsPage } from '@/features/notifications/NotificationsPage';
import { NotificationRulesPage } from '@/features/notifications/NotificationRulesPage';
import { CustomAlarmsPage } from '@/features/notifications/CustomAlarmsPage';
import { ManualsPage } from '@/features/manuals/ManualsPage';
import { CustomAlarmsManual } from '@/features/manuals/CustomAlarmsManual';
import { ProfilePage } from '@/features/profile/ProfilePage';
import { TenantsPage } from '@/features/admin/TenantsPage';
import { OperatorsPage } from '@/features/admin/OperatorsPage';
import { FeatureUsagePage } from '@/features/admin/FeatureUsagePage';
import { PlatformInfoPage } from '@/features/admin/PlatformInfoPage';
import { ClientesPage } from '@/features/revenda/ClientesPage';
import { ChipsPage } from '@/features/chips/ChipsPage';
import { BillingPage } from '@/features/billing/BillingPage';
import { InstallPage } from '@/features/install/InstallPage';
import { BIPage } from '@/features/bi/BIPage';
import { FinanceiroPage } from '@/features/bi/FinanceiroPage';
import { UsersPage } from '@/features/users/UsersPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { AddDevicePage } from '@/features/settings/AddDevicePage';
import { ClientsPage } from '@/features/settings/ClientsPage';
import { LinksPage } from '@/features/settings/LinksPage';
import { NotFoundPage } from '@/features/NotFoundPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/devices" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/devices/:id" element={<DeviceDetailPage />} />
          <Route path="/devices/:id/health" element={<HealthPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports/events" element={<EventsReportPage />} />
          <Route path="/reports/summary" element={<SummaryReportPage />} />
          <Route path="/reports/trips" element={<TripsReportPage />} />
          <Route path="/reports/stops" element={<StopsReportPage />} />
          <Route path="/reports/route" element={<RouteReportPage />} />
          <Route path="/reports/speed" element={<SpeedReportPage />} />
          <Route path="/reports/insurance" element={<InsuranceReportPage />} />
          <Route path="/reports/usage" element={<UsageReportPage />} />
          <Route path="/reports/geofence-events" element={<GeofenceEventsReportPage />} />
          <Route path="/reports/hours" element={<HoursReportPage />} />
          <Route path="/geofences" element={<GeofencesPage />} />
          <Route path="/conditions" element={<ConditionsPage />} />
          <Route path="/points" element={<PointsPage />} />
          <Route path="/points/:id" element={<PointDetailPage />} />
          <Route path="/navigator" element={<NavigatorPage />} />
          <Route path="/app-routes" element={<RoutesPage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="/checklist" element={<ChecklistPage />} />
          <Route path="/rentals" element={<RentalPage />} />
          <Route path="/central" element={<CentralPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/notifications/rules" element={<NotificationRulesPage />} />
          <Route path="/notifications/custom" element={<CustomAlarmsPage />} />
          {/* manual migrou para a area de Manuais; o link antigo segue valendo */}
          <Route path="/notifications/custom/manual" element={<Navigate to="/manuais/alarmes-personalizados" replace />} />
          <Route path="/manuais" element={<ManualsPage />} />
          <Route path="/manuais/alarmes-personalizados" element={<CustomAlarmsManual />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/bi" element={<BIPage />} />
          <Route path="/financeiro" element={<FinanceiroPage />} />
          <Route path="/admin/tenants" element={<TenantsPage />} />
          <Route path="/admin/operators" element={<OperatorsPage />} />
          <Route path="/admin/feature-usage" element={<FeatureUsagePage />} />
          <Route path="/admin/info" element={<PlatformInfoPage />} />
          <Route path="/revenda/clientes" element={<ClientesPage />} />
          <Route path="/chips" element={<ChipsPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/devices/new" element={<AddDevicePage />} />
          <Route path="/settings/devices/edit/:id" element={<AddDevicePage />} />
          <Route path="/settings/clients" element={<ClientsPage />} />
          <Route path="/settings/notifications" element={<NotificationRulesPage />} />
          <Route path="/settings/links" element={<LinksPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
